var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"whatsapp-button"}},[_c('a',{staticClass:"d-none",attrs:{"target":"_blank","href":"https://wa.me/5521967015291"}},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":require("@/assets/images/whatsapp.png")}})])])
}]

export { render, staticRenderFns }